/**
 * JapanHaul Wishlist Library
 * Consolidated from japanhaul-theme wishlist modules
 * Dependencies: jQuery, Handlebars, FoxTheme.Currency.formatMoney
 */

window.JH = window.JH || {};

/* =========================================
   Utility: Format money using FoxTheme or fallback
   ========================================= */
JH._formatMoney = function (cents, format) {
  if (typeof FoxTheme !== 'undefined' && FoxTheme.Currency && FoxTheme.Currency.formatMoney) {
    return FoxTheme.Currency.formatMoney(cents, format);
  }
  if (typeof Shopify !== 'undefined' && JH._formatMoney) {
    return JH._formatMoney(cents, format);
  }
  return '$' + (cents / 100).toFixed(2);
};

/* =========================================
   Utility: Replace moment.js date formatting
   ========================================= */
JH._formatDate = function (dateStr) {
  var months = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];
  var d = new Date(dateStr);
  if (isNaN(d.getTime())) return dateStr;
  var month = months[d.getMonth()];
  var day = ('0' + d.getDate()).slice(-2);
  var year = d.getFullYear();
  return month + ' ' + day + ', ' + year;
};

/* =========================================
   Utility: Fetch live availability from Shopify
   ========================================= */
JH._fetchLiveAvailability = function (handles, callback) {
  if (!handles || handles.length === 0) {
    return callback({});
  }

  var deferreds = [];
  var availabilityMap = {};

  handles.forEach(function (handle) {
    var deferred = $.ajax({
      url: '/products/' + handle + '.js',
      dataType: 'json',
      timeout: 3000
    })
      .done(function (data) {
        if (data && typeof data.available !== 'undefined') {
          availabilityMap[handle] = data.available;
        }
      })
      .fail(function () {
        // Fail-safe: omit handle from map, caller keeps app's original value
      });

    deferreds.push(deferred);
  });

  // Wait for all requests to settle (success or failure)
  $.when.apply($, deferreds).always(function () {
    callback(availabilityMap);
  });
};

/* =========================================
   Core: JH.Wishlist
   ========================================= */
JH.Wishlist = (function () {
  function Wishlist(apiUrl, customerId) {
    this.apiUrl = apiUrl;
    this.customerId = customerId;
    this.productKey = 'JH.Wishlist.ProductIds';
    this.wishlistKey = 'JH.Wishlist.WishlistId';
    this.customerKey = 'JH.Wishlist.CustomerId';

    this.token = localStorage.getItem(this.wishlistKey);
    this.wishlists = {};
  }

  Wishlist.prototype.refreshCount = function () {
    var count = this.selectedProductIds().length;
    var $el = $('[data-role=wishlist-count]');
    $el.text(count);
    if (count > 0) {
      $el.show();
    } else {
      $el.hide();
    }
  };

  Wishlist.prototype.refresh = function () {
    this.refreshCount();
    var ids = this.selectedProductIds();
    var self = this;

    $('[data-toggle=add-to-wishlist]').each(function (i, el) {
      var $el = $(el);
      self.toggleElement($el, ids.indexOf(el.dataset.id.toString()) !== -1);
    });
  };

  Wishlist.prototype.init = function () {
    var self = this;

    $('body').on('click', '[data-toggle=add-to-wishlist]', function (e) {
      e.preventDefault();
      e.stopPropagation();
      self.toggle(this.dataset.id);
      self.refresh();

      // Invalidate cache and re-fetch in background
      JH.WishlistDrawer.invalidate();
      JH.WishlistDrawer.preload();

      // Auto-refresh wishlist drawer if it's open
      if ($('#WishlistDrawer').hasClass('is-open')) {
        JH.WishlistDrawer.loadProducts();
      }
    });

    $('body').on('click', '[data-toggle=remove-from-wishlist]', function (e) {
      e.preventDefault();
      self.remove(this.dataset.id.toString());
    });

    $('body').on('click', '[data-toggle=select-wishlist]', function (e) {
      var id = this.dataset.id;
      e.preventDefault();
      self.activateWishlist(id);
      JH.WishlistDrawer.loadProducts();
      JH.WishlistDrawer.renderWishlists();
    });

    self.ready();
    self.refresh();

    // Refresh wishlist state when quick view content loads
    document.addEventListener('quick-view:loaded', function () {
      self.refresh();
    });

    JH.WishlistDrawerForm.init();
  };

  Wishlist.prototype.toggleElement = function ($el, isActive) {
    if ($el.data('type') == 'big') {
      var $textSpan = $el.find('span').last();
      $textSpan.text(isActive ? 'Remove From Wishlist' : 'Add To Wishlist');
    }

    if (isActive) {
      $el.addClass('active');
    } else {
      $el.removeClass('active');
    }
  };

  Wishlist.prototype.toggle = function (productId) {
    var isActive = this.toggleLocal(productId);

    if (this.customerId) {
      this.ajaxProduct(productId, isActive);
    }

    return isActive;
  };

  Wishlist.prototype.ajaxProduct = function (productId, isActive) {
    if (typeof this.token === 'string' && this.token.length > 0) {
      this.postProduct(productId, isActive);
    } else {
      var self = this;
      this.createWishlist(
        {
          product_ids: this.selectedProductIds(),
          form_type: 'auto',
        },
        function (isPersisted, resp) {
          if (isPersisted) {
            self.activateWishlist(resp.data.id);
          }
        }
      );
    }
  };

  Wishlist.prototype.selectedProductIds = function () {
    var str = localStorage.getItem(this.productKey) || JSON.stringify([]);
    var arr;
    try {
      arr = JSON.parse(str);
    } catch (e) {}
    arr = arr || [];
    return arr;
  };

  Wishlist.prototype.toggleLocal = function (productId, forceRemove) {
    var id = productId.toString();
    var arr = this.selectedProductIds();
    var isActive;

    if (arr.indexOf(id) !== -1 || forceRemove) {
      arr = arr.filter(function (i) { return i != id; });
      isActive = false;
    } else {
      arr.push(id);
      isActive = true;
    }

    localStorage.setItem(this.productKey, JSON.stringify(arr));
    return isActive;
  };

  Wishlist.prototype.postProduct = function (productId, isActive) {
    var self = this;
    $.ajax({
      url: self.apiUrl + '/wishlists/' + this.token + '/' + (isActive ? 'add_product' : 'remove_product'),
      type: isActive ? 'POST' : 'DELETE',
      data: {
        shop: Shopify.shop,
        customer_id: self.customerId,
        product_id: productId,
      },
      success: function (resp) {
        self.setWishlist(resp.data);
        if (!self.token) {
          self.activateWishlist(resp.data.id);
        }
      },
    });
  };

  Wishlist.prototype.isProductSelected = function (productId) {
    return this.selectedProductIds().indexOf(productId.toString()) !== -1;
  };

  Wishlist.prototype.remove = function (productId) {
    this.toggleLocal(productId, true);
    this.refreshCount();
    JH.WishlistDrawer.invalidate();

    if (this.customerId) {
      this.postProduct(productId, false);
    }

    var $drawerItem = $('[data-role="wishlist-item"][data-id="' + productId + '"]');
    $drawerItem.find('.ajaxcart__row').addClass('is-loading');
    $drawerItem.addClass('is-removed');

    setTimeout(function () {
      $drawerItem.remove();

      // Update drawer header count
      var remaining = $('#WishlistProductsContainer').find('.ajaxcart__product').length;
      var $countEl = $('#WishlistDrawerCount');
      if (remaining > 0) {
        $countEl.text(remaining).removeAttr('hidden');
      } else {
        $countEl.attr('hidden', '');
      }

      // If no items left, replace form with empty message
      if (remaining === 0) {
        var $container = $('#WishlistProductsContainer');
        $container.find('form').remove();
        $container.html('<div class="wishlist-drawer__empty"><p>Your wishlist is empty</p><span>Browse our collection and add items you love!</span></div>');
      }
    }, 500);

    var $drawerCount = $('.list-item[data-id=' + window.japanhaulapp.token + '] .list-count');
    if ($drawerCount.length > 0) {
      var i = parseInt($drawerCount.text().trim().split(' ')[0]) - 1;
      $drawerCount.text(i + ' items');
    }

    this.refresh();
  };

  Wishlist.prototype.ready = function () {
    var self = this;
    if (!this.customerLoggedIn() && self.token && self.token.length > 0) {
      self.token = null;
      localStorage.removeItem(this.wishlistKey);
      localStorage.removeItem(this.customerKey);
      localStorage.removeItem(this.productKey);
      return;
    } else if (!this.customerLoggedIn()) {
      return;
    }

    if (!self.token && self.selectedProductIds().length > 0) {
      this.createWishlist(
        {
          product_ids: this.selectedProductIds(),
          form_type: 'auto',
        },
        function (isPersisted, resp) {
          if (isPersisted) {
            self.activateWishlist(resp.data.id);
          }
        }
      );
    } else if (!self.token && self.selectedProductIds().length === 0) {
      this.getWishlist('latest', function (resp) {
        var data = resp.data;
        if (data !== null && data !== undefined && typeof data == 'object') {
          self.activateWishlist(data.id);
        }
      });
    }
  };

  Wishlist.prototype.customerLoggedIn = function () {
    return typeof this.customerId === 'string' && this.customerId.length > 0;
  };

  Wishlist.prototype.getAllWishlists = function (callback) {
    if (!this.customerLoggedIn()) {
      return callback([], false);
    }
    var self = this;
    $.ajax({
      url: this.apiUrl + '/wishlists',
      method: 'GET',
      data: {
        shop: Shopify.shop,
        customer_id: this.customerId,
      },
      success: function (resp) {
        self.setWishlists(resp.data);
        callback(self.wishlists);
      },
    });
  };

  Wishlist.prototype.getWishlist = function (wishlistId, callback) {
    if (!this.customerLoggedIn()) {
      return callback(null);
    }
    var self = this;
    $.ajax({
      url: this.apiUrl + '/wishlists/' + wishlistId,
      method: 'GET',
      data: {
        shop: Shopify.shop,
        customer_id: this.customerId,
      },
      success: function (resp) {
        if (resp.data) {
          self.setWishlist(resp.data);
        }
        callback(resp);
      },
      error: function (resp) {
        callback(resp);
      },
    });
  };

  Wishlist.prototype.createWishlist = function (params, callback) {
    var self = this;
    $.ajax({
      type: 'POST',
      url: this.apiUrl + '/wishlists',
      data: Object.assign(params, {
        shop: Shopify.shop,
        customer_id: this.customerId,
      }),
      success: function (resp) {
        self.setWishlist(resp.data);
        callback(true, resp);
      },
      error: function (resp) {
        callback(false, resp);
      },
    });
  };

  Wishlist.prototype.updateWishlist = function (id, params, callback) {
    var self = this;
    $.ajax({
      type: 'PUT',
      url: this.apiUrl + '/wishlists/' + id,
      data: Object.assign(params, {
        shop: Shopify.shop,
        customer_id: this.customerId,
      }),
      success: function (resp) {
        self.setWishlist(resp.data);
        callback(true, resp);
      },
      error: function (resp) {
        callback(false, resp);
      },
    });
  };

  Wishlist.prototype.destroyWishlist = function (id, callback) {
    var self = this;
    $.ajax({
      type: 'DELETE',
      url: this.apiUrl + '/wishlists/' + id,
      data: {
        shop: Shopify.shop,
        customer_id: this.customerId,
      },
      success: function (resp) {
        self.removeWishlist(id);
        callback(true, resp);
      },
      error: function (resp) {
        callback(false, resp);
      },
    });
  };

  Wishlist.prototype.getCurrentProducts = function (callback) {
    $.ajax({
      type: 'GET',
      url: this.apiUrl + '/products',
      data: {
        ids: this.selectedProductIds().join(','),
        customer_id: this.customerId,
        shop: Shopify.shop,
      },
      dataType: 'json',
      success: function (resp) {
        callback(resp);
      },
    });
  };

  Wishlist.prototype.normalizeWishlist = function (data) {
    return {
      id: data.id,
      isActive: data.id === this.token,
      name: data.attributes.name,
      customerId: data.attributes.customer_id,
      isPrivate: data.attributes.wishlist_type === 'private',
      productIds: data.attributes.product_ids,
      lastUpdatedAt: JH._formatDate(data.attributes.updated_at),
    };
  };

  Wishlist.prototype.removeWishlist = function (id) {
    delete this.wishlists[id];

    if (this.token === id && Object.values(this.wishlists).length > 0) {
      this.activateWishlist(Object.values(this.wishlists)[0].id);
    } else if (this.token === id) {
      this.token = null;
      localStorage.removeItem(this.wishlistKey);
      localStorage.removeItem(this.customerKey);
      localStorage.removeItem(this.productKey);
    }
  };

  Wishlist.prototype.setWishlists = function (data) {
    var self = this;
    data.forEach(function (wishlist) {
      self.wishlists[wishlist.id] = self.normalizeWishlist(wishlist);
    });
  };

  Wishlist.prototype.setWishlist = function (data) {
    return (this.wishlists[data.id] = this.normalizeWishlist(data));
  };

  Wishlist.prototype.activateWishlist = function (id) {
    var self = this;
    Object.values(self.wishlists).forEach(function (wishlist) {
      wishlist.isActive = wishlist.id === id;
      self.wishlists[wishlist.id] = wishlist;
    });

    var wishlist = this.wishlists[id];
    localStorage.setItem(this.wishlistKey, wishlist.id);
    localStorage.setItem(this.productKey, JSON.stringify(wishlist.productIds));
    localStorage.setItem(this.customerKey, wishlist.customerId);

    this.token = wishlist.id;
    this.refresh();
  };

  return Wishlist;
})();

/* =========================================
   Drawer: JH.WishlistDrawer
   ========================================= */
JH.WishlistDrawer = {
  _cachedHTML: null,
  _cachedItems: null,
  _template: null,
  _dirty: true,
  _loading: false,
  _pendingCallbacks: [],
  _version: 0
};

// Pre-load wishlist products on page load (background fetch)
// so drawer opens instantly like cart drawer
JH.WishlistDrawer.preload = function () {
  if (!window.japanhaulapp || window.japanhaulapp.selectedProductIds().length === 0) {
    this._cachedHTML = '';
    this._dirty = false;
    return;
  }
  this._fetchAndCache();
};

// Build rendered HTML from API response and cache it
JH.WishlistDrawer._fetchAndCache = function (callback) {
  var self = this;
  if (callback) self._pendingCallbacks.push(callback);
  if (self._loading) return;
  self._loading = true;
  var fetchVersion = self._version;

  window.japanhaulapp.getCurrentProducts(function (resp) {
    // Discard stale response if wishlist changed while fetching
    if (fetchVersion !== self._version) return;

    var source = document.getElementById('WishlistProductsTemplate').innerHTML;
    var moneyFormat = window.FoxTheme.settings.moneyFormat;
    var template = Handlebars.compile(source);
    var items = [];

    $.each(resp.data, function (index, product) {
      var obj = product.attributes;

      var imgUrl = '';
      if (obj.featured_image_url) {
        imgUrl = obj.featured_image_url.replace(/(\.[^.]*)$/, '_small$1').replace('http:', '');
      }

      items.push({
        id: product.id,
        url: location.origin + '/products/' + obj.handle,
        handle: obj.handle,
        type: obj.type,
        title: obj.title,
        imageUrl: imgUrl,
        available: obj.available,
        defaultVariantId: obj.default_variant_id,
        priceMin: JH._formatMoney(parseFloat(obj.price_min) * 100, moneyFormat),
        comparePriceMin: JH._formatMoney(parseFloat(obj.compare_price_min) * 100, moneyFormat),
        onSale: obj.price_min < obj.compare_price_min,
        preOrderItem:
          product.metafields && product.metafields.product
            ? product.metafields.product.pre_order_item
            : null,
      });
    });

    // Fetch live availability from Shopify to override stale app API flags
    var handles = items.map(function (item) { return item.handle; });
    JH._fetchLiveAvailability(handles, function (availabilityMap) {
      // Discard stale response if wishlist changed while fetching
      if (fetchVersion !== self._version) return;

      // Override availability for items where we have live data
      items.forEach(function (item) {
        if (availabilityMap.hasOwnProperty(item.handle)) {
          item.available = availabilityMap[item.handle];
        }
      });

      // Now render template with corrected availability
      self._cachedHTML = template({ items: items });
      self._cachedItems = items;
      self._template = template;
      self._dirty = false;
      self._loading = false;

      // Run all pending callbacks (handles race between preload and drawer open)
      var callbacks = self._pendingCallbacks.splice(0);
      callbacks.forEach(function (cb) { cb(); });

      // Fetch Shopify images in background and update cache + DOM
      // So next drawer open already has correct images (no flicker)
      self._updateShopifyImages(fetchVersion);
    });
  });
};

// Fetch Shopify images and update both the cache and DOM (if visible)
JH.WishlistDrawer._updateShopifyImages = function (fetchVersion) {
  var self = this;

  if (!self._cachedItems) return;

  $.each(self._cachedItems, function (i, item) {
    if (item.handle) {
      $.getJSON('/products/' + item.handle + '.json')
        .then(function (data) {
          if (fetchVersion !== self._version) return;
          if (data.product && data.product.image && data.product.image.src) {
            var newSrc = data.product.image.src.replace(/(\.[^.]*)$/, '_small$1').replace('http:', '');
            // Update the cached item so re-renders use Shopify URL
            item.imageUrl = newSrc;
            // Re-render cache with updated image URLs
            if (self._template) {
              self._cachedHTML = self._template({ items: self._cachedItems });
            }
            // Also update DOM if drawer is currently open
            var $container = $('#WishlistProductsContainer');
            $container.find('[data-id="' + item.id + '"] img').attr('src', newSrc);
          }
        });
    }
  });
};

// Mark cache as stale so next open re-fetches
JH.WishlistDrawer.invalidate = function () {
  this._dirty = true;
  this._version++;
  this._loading = false; // allow new fetch to start
  this._pendingCallbacks = [];
};

// Called when drawer opens
JH.WishlistDrawer.load = function () {
  var $container = $('#WishlistProductsContainer');
  var self = this;

  if (!this._dirty && this._cachedHTML !== null) {
    // Cache hit — show instantly (like cart drawer, images already correct)
    $container.empty().append(this._cachedHTML);
    window.StampedFn && window.StampedFn.reloadUGC();
  } else {
    // Cache miss — show spinner and fetch
    $container.empty().append(
      '<div class="wishlist-drawer__loading">' +
        '<svg class="wishlist-spinner" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">' +
          '<circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" stroke-width="2" stroke-dasharray="31.4 31.4" stroke-linecap="round"/>' +
        '</svg>' +
      '</div>'
    );
    this._fetchAndCache(function () {
      var $newContent = $(self._cachedHTML);
      $newContent.css('opacity', '0');
      $container.empty().append($newContent);
      requestAnimationFrame(function () {
        $newContent.css({ transition: 'opacity 0.3s ease', opacity: '1' });
      });
      window.StampedFn && window.StampedFn.reloadUGC();
    });
  }

  JH.WishlistDrawer.loadWishlists();
};

// Re-fetch and update drawer in place (used when drawer is open and items change)
JH.WishlistDrawer.loadProducts = function () {
  var $container = $('#WishlistProductsContainer');
  var self = this;

  this._fetchAndCache(function () {
    var $newContent = $(self._cachedHTML);
    $newContent.css('opacity', '0');
    $container.empty().append($newContent);
    requestAnimationFrame(function () {
      $newContent.css({ transition: 'opacity 0.3s ease', opacity: '1' });
    });
    window.StampedFn && window.StampedFn.reloadUGC();
  });
};

JH.WishlistDrawer.renderWishlists = function () {
  var $container = $('#WishlistItemsContainer');
  $container.empty();
  var source = document.getElementById('WishlistItemsTemplate').innerHTML;
  var template = Handlebars.compile(source);

  var variables = { wishlists: Object.values(window.japanhaulapp.wishlists) };
  $container.append(template(variables));

  if (
    typeof window.japanhaulapp.token == 'string' &&
    window.japanhaulapp.token.length > 0
  ) {
    var id = window.japanhaulapp.token;
    var wishlist = window.japanhaulapp.wishlists[id];

    if (wishlist !== undefined && wishlist !== null) {
      $('#WishlistDrawer .drawer__title').text(wishlist.name);
    } else {
      $('#WishlistDrawer .drawer__title').text('My Wishlist');
    }
  }
};

JH.WishlistDrawer.loadWishlists = function () {
  if (window.japanhaulapp.customerLoggedIn()) {
    window.japanhaulapp.getAllWishlists(function () {
      JH.WishlistDrawer.renderWishlists();
    });
  }
};

/* =========================================
   Drawer Form: JH.WishlistDrawerForm
   ========================================= */
JH.WishlistDrawerForm = {
  init: function () {
    $('body').on('click', '[data-toggle=new-wishlist-drawer-form]', function (e) {
      e.preventDefault();
      $('#wishlist-drawer-form').slideToggle();
    });

    $('body').on('submit', '#wishlist-drawer-form', function (e) {
      e.preventDefault();
      JH.WishlistDrawerForm.post();
    });
  },

  post: function () {
    var $form = $('#wishlist-drawer-form');

    var params = {
      name: $form.find('[name="wishlist[name]"]').val(),
      wishlist_type: $form.find('[name="wishlist[wishlist_type]"]').val(),
      form_type: 'manual',
    };

    window.japanhaulapp.createWishlist(params, function (isPersisted, resp) {
      if (!isPersisted) {
        for (var key in resp.responseJSON) {
          $form
            .find('.drawer-form-errors')
            .empty()
            .prepend(
              '<div class="errors">' +
                key.charAt(0).toUpperCase() +
                key.slice(1) +
                ' ' +
                resp.responseJSON[key][0] +
                '</div>'
            );
        }
      } else {
        window.japanhaulapp.activateWishlist(resp.data.id);
        JH.WishlistDrawer.loadProducts();
        JH.WishlistDrawer.renderWishlists();
      }
    });
  },
};

/* =========================================
   Page: JH.WishlistPage
   ========================================= */
JH.WishlistPage = (function () {
  function WishlistPage(app) {
    this.app = app;

    var attrs = location.href.split('/');
    this.token = attrs[attrs.length - 1].split('?')[0];
    this.moneyFormat = window.FoxTheme.settings.moneyFormat;
    this.page = {};
  }

  WishlistPage.prototype.init = function () {
    this.renderPage();
  };

  WishlistPage.prototype.renderPage = function () {
    var self = this;
    var app = this.app;
    this.getWishlistPage(function (resp) {
      app.setWishlists(resp.wishlists);
      self.page = self.remapObject(resp);
      self.renderMetaTags(resp);

      // Fetch correct images and live availability from Shopify
      var imagePromises = [];
      if (self.page.products) {
        self.page.products.forEach(function (product) {
          var handle = product.url.replace('/products/', '');
          if (handle) {
            imagePromises.push(
              $.ajax({
                url: '/products/' + handle + '.js',
                dataType: 'json'
              })
                .then(function (data) {
                  if (data.product && data.product.image && data.product.image.src) {
                    product.featuredImageUrl = data.product.image.src;
                  }
                  // Also update availability from live Shopify data
                  if (data && typeof data.available !== 'undefined') {
                    product.available = data.available;
                  }
                })
                .fail(function () {})
            );
          }
        });
      }

      $.when.apply($, imagePromises).always(function () {
        if (self.page.products && self.page.products[0]) {
          self.page.firstProduct = self.page.products[0];
        }
        self.render();
      });
    });
  };

  WishlistPage.prototype.render = function () {
    this.renderContents();
    if (this.page.isOwner) {
      this.renderWishlists();
    }
  };

  WishlistPage.prototype.renderContents = function () {
    var $container = $('#WishlistPageContainer');
    $container.empty();
    var source = document.getElementById('WishlistPageTemplate').innerHTML;
    var template = Handlebars.compile(source);
    $container.append(template(this.page));
    this.afterInit();
  };

  WishlistPage.prototype.renderWishlists = function () {
    var $container = $('#WishlistGroupContainer');
    $container.empty();
    var source = document.getElementById('WishlistGroupTemplate').innerHTML;
    var template = Handlebars.compile(source);

    var variables = { wishlists: Object.values(this.app.wishlists) };
    $container.append(template(variables));
    this.bindDestroy($container);
  };

  WishlistPage.prototype.afterInit = function () {
    this.app.refresh();
    if (typeof __sharethis__ !== 'undefined') {
      __sharethis__.initialize();
    }
  };

  WishlistPage.prototype.remapObject = function (resp) {
    var wishlist = this.app.normalizeWishlist(resp.wishlist);
    var object = {
      wishlist: wishlist,
      customer: resp.customer,
      isOwner: this.app.customerId === wishlist.customerId,
    };
    var moneyFormat = this.moneyFormat;

    object.products = resp.products.map(function (product) {
      var description = $('<div>' + product.body_html + '</div>').text();
      description =
        description.length > 150
          ? description.substring(0, 150) + '...'
          : description.substring(0, 150);

      return {
        id: product.id,
        defaultVariantId: product.default_variant_id,
        available: product.available,
        title: product.title,
        description: description,
        onSale: product.price_min < product.compare_price_min,
        comparePriceMin: JH._formatMoney(product.compare_price_min * 100, moneyFormat),
        priceMin: JH._formatMoney(product.price_min * 100, moneyFormat),
        productType: product.product_type,
        featuredImageUrl: product.featured_image_url,
        url: '/products/' + product.handle,
        preOrderItem:
          product.metafields && product.metafields.product
            ? product.metafields.product.pre_order_item
            : null,
      };
    });

    if (object.products && object.products[0]) {
      object.firstProduct = object.products[0];
    }

    return object;
  };

  WishlistPage.prototype.getWishlistPage = function (callback) {
    $.ajax({
      url: this.app.apiUrl + '/wishlist_pages/' + this.token,
      method: 'GET',
      data: {
        shop: Shopify.shop,
        customer_id: this.app.customerId,
      },
      success: callback,
      error: function () {
        location.href = '/';
      },
    });
  };

  WishlistPage.prototype.renderMetaTags = function (object) {
    var product = object.products[0];
    $('head')
      .find('title, meta[property="og:title"], meta[property="og:type"]')
      .remove();

    if (product !== null && product !== undefined) {
      $('head')
        .find(
          'meta[property="og:description"], meta[property="og:image"], meta[property="og:image:secure_url"], meta[name="description"]'
        )
        .remove();

      var description = $('<div>' + product.body_html + '</div>').text();
      $('head').prepend(
        '<meta property="og:image" content="' + product.featured_image_url + '">'
      );
      $('head').prepend(
        '<meta property="og:image:secure_url" content="' + product.featured_image_url + '">'
      );
      $('head').prepend(
        '<meta property="og:description" content="' + description + '">'
      );
      $('head').prepend(
        '<meta name="description" content="' + description + '">'
      );
    }

    $('head').prepend('<meta property="og:type" content="article">');
    $('head').prepend(
      '<meta property="og:title" content="' +
        object.wishlist.attributes.name +
        ' | Wishlist - Japan Haul">'
    );
    $('head').prepend(
      '<title>' +
        object.wishlist.attributes.name +
        ' | Product Review - Japan Haul</title>'
    );
  };

  WishlistPage.prototype.bindDestroy = function ($container) {
    var self = this;
    $container.find('[data-toggle=delete-wishlist]').on('click', function (e) {
      e.preventDefault();
      var id = this.dataset.id;

      if (confirm(this.dataset.confirm)) {
        self.app.destroyWishlist(id, function (isPersisted) {
          if (!isPersisted) return;

          if (
            self.page.wishlist.id === id &&
            Object.values(self.app.wishlists).length > 0
          ) {
            location.href =
              '/pages/wishlist/' + Object.values(self.app.wishlists)[0].id;
          } else if (self.page.wishlist.id === id) {
            location.href = '/';
          } else {
            self.renderWishlists();
          }
        });
      }
    });
  };

  return WishlistPage;
})();

/* =========================================
   Account: JH.WishlistAccount
   ========================================= */
JH.WishlistAccount = (function () {
  function WishlistAccount(app) {
    this.app = app;
  }

  WishlistAccount.prototype.init = function () {
    this.render();
  };

  WishlistAccount.prototype.render = function () {
    var self = this;
    this.app.getAllWishlists(function () {
      self.renderHTML();
      self.bindDestroy();
    });
  };

  WishlistAccount.prototype.renderHTML = function () {
    var container = document.getElementById('MyWishlistContainer');
    var source = document.getElementById('MyWishlistTemplate').innerHTML;
    var template = Handlebars.compile(source);
    container.innerHTML = template({
      wishlists: Object.values(this.app.wishlists),
    });
  };

  WishlistAccount.prototype.bindDestroy = function () {
    var self = this;
    var $container = $('#MyWishlistContainer');
    $container.on('click', '[data-toggle=delete-wishlist]', function (e) {
      var id = this.dataset.id;
      var isDeleted = confirm(this.dataset.confirm);

      if (isDeleted) {
        self.app.destroyWishlist(id, function (isPersisted) {
          if (!isPersisted) return;
          self.renderHTML();
        });
      }
    });
  };

  return WishlistAccount;
})();

/* =========================================
   Modal: JH.WishlistModal
   ========================================= */
JH.WishlistModal = (function () {
  function WishlistModal(app, pageType) {
    this.app = app;
    this.pageType = pageType;
    this.token = null;
    this.$el = $('#WishlistModal');
  }

  WishlistModal.prototype.init = function () {
    this.bind();
  };

  WishlistModal.prototype.bind = function () {
    var self = this;

    $('body').on('click', '[data-toggle=wishlist-modal]', function (e) {
      e.preventDefault();

      if (this.dataset.type === 'new') {
        self.newForm();
      } else {
        self.editForm(this.dataset.id);
      }

      // Open modal
      var target = this.dataset.target;
      $(target).addClass('is-open');
      $('body').addClass('modal-open');
    });

    $('body').on('click', '[data-toggle=wishlist-modal-save]', function (e) {
      self.disableForm();
      self.saveForm();
    });

    // Close modal
    $('body').on('click', '[data-toggle=modal-close]', function (e) {
      e.preventDefault();
      $('.modal-box').removeClass('is-open');
      $('body').removeClass('modal-open');
    });
  };

  WishlistModal.prototype.newForm = function () {
    this.token = null;
    this.$el.find('.errors').remove();
    this.$el.find('.modal-header .title').text('New Wishlist');
    this.$el.find('[name="wishlist[name]"]').val('');
    this.$el.find('[name="wishlist[wishlist_type]"]').val('private');
  };

  WishlistModal.prototype.editForm = function (token) {
    this.token = token;
    var wishlist = this.app.wishlists[token];

    this.$el.find('.errors').remove();
    this.$el.find('.modal-header .title').text('Edit Wishlist');
    this.$el.find('[name="wishlist[name]"]').val(wishlist.name);
    this.$el
      .find('[name="wishlist[wishlist_type]"]')
      .val(wishlist.isPrivate ? 'private' : 'public');
  };

  WishlistModal.prototype.saveForm = function () {
    var self = this;

    var params = {
      name: this.$el.find('[name="wishlist[name]"]').val(),
      wishlist_type: this.$el.find('[name="wishlist[wishlist_type]"]').val(),
    };

    if (this.token) {
      this.app.updateWishlist(
        this.token,
        { wishlist: params },
        function (isPersisted, resp) {
          self.saveCallbacks(isPersisted, resp, false);
        }
      );
    } else {
      params['form_type'] = 'manual';
      this.app.createWishlist(params, function (isPersisted, resp) {
        self.saveCallbacks(isPersisted, resp, true);
      });
    }
  };

  WishlistModal.prototype.saveCallbacks = function (isPersisted, resp, isNew) {
    if (isPersisted) {
      if (this.pageType === 'single') {
        this.singlePageCallbacks(resp, isNew);
      } else if (this.pageType === 'account') {
        this.accountPageCallbacks(resp, isNew);
      }
    } else {
      var $modal = this.$el;
      for (var key in resp.responseJSON) {
        $modal.find('.form .errors').remove();
        $modal
          .find('.form')
          .prepend(
            '<div class="errors">' +
              key.charAt(0).toUpperCase() +
              key.slice(1) +
              ' ' +
              resp.responseJSON[key][0] +
              '</div>'
          );
      }
    }

    this.enableForm();
  };

  WishlistModal.prototype.singlePageCallbacks = function (resp, isNew) {
    if (isNew) {
      this.app.activateWishlist(resp.data.id);
      location.href = '/pages/wishlist/' + resp.data.id;
    } else {
      var wishlist = this.app.wishlists[resp.data.id];
      this.singlePageUpdateCallbacks(wishlist);
    }
  };

  WishlistModal.prototype.singlePageUpdateCallbacks = function (wishlist) {
    if (typeof window.wishlistPage !== 'undefined' && window.wishlistPage) {
      window.wishlistPage.page.wishlist = wishlist;
      window.wishlistPage.render();
    }

    $('.modal-box').removeClass('is-open');
    $('body').removeClass('modal-open');
  };

  WishlistModal.prototype.accountPageCallbacks = function (resp, isNew) {
    if (isNew) {
      this.app.activateWishlist(resp.data.id);
      window.myWishlist.renderHTML();
    } else {
      window.myWishlist.renderHTML();
    }

    $('.modal-box').removeClass('is-open');
    $('body').removeClass('modal-open');
  };

  WishlistModal.prototype.enableForm = function () {
    $('[data-toggle=wishlist-modal-save]').attr('disabled', false).text('Save');
  };

  WishlistModal.prototype.disableForm = function () {
    $('[data-toggle=wishlist-modal-save]')
      .attr('disabled', true)
      .text('Saving..');
  };

  return WishlistModal;
})();

/* =========================================
   Public: JH.WishlistPublic
   ========================================= */
JH.WishlistPublic = (function () {
  function WishlistPublic(app, productId) {
    this.productId = productId;
    this.app = app;
  }

  WishlistPublic.prototype.init = function () {
    var self = this;
    this.getWishlists(function (resp) {
      if (typeof resp !== 'undefined' && resp.data && resp.data.length > 0) {
        self.render(resp);
      }
    });
  };

  WishlistPublic.prototype.getWishlists = function (callback) {
    $.ajax({
      method: 'GET',
      url: this.app.apiUrl + '/wishlist_pages/product',
      data: {
        shop: Shopify.shop,
        product_id: this.productId,
      },
      success: callback,
      error: callback,
    });
  };

  WishlistPublic.prototype.render = function (resp) {
    var $container = document.getElementById('ProductUserWishlistContainer');
    if (!$container) return;
    var source = document.getElementById('ProductUserWishlistTemplate');
    if (!source) return;

    var template = Handlebars.compile(source.innerHTML);
    var variables = this.remapVariables(resp);
    $container.innerHTML = template(variables);
  };

  WishlistPublic.prototype.remapVariables = function (resp) {
    var customers = {};
    var filtered = resp.included.filter(function (c) {
      return c.type === 'customers';
    });
    filtered.forEach(function (c) {
      customers[c.id] = {
        initials: c.attributes.initials,
        first_name: c.attributes.first_name,
      };
    });

    return resp.data.map(function (wishlist) {
      return {
        id: wishlist.id,
        name: wishlist.attributes.name,
        url: '/pages/wishlist/' + wishlist.id,
        customer: customers[wishlist.relationships.customer.data.id],
      };
    });
  };

  return WishlistPublic;
})();
